import { render } from "./GeneralModal.vue?vue&type=template&id=43579118&scoped=true"
import script from "./GeneralModal.vue?vue&type=script&lang=js"
export * from "./GeneralModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43579118"]])

export default __exports__